import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'is_the_fac_failing_to_pay_any_worker_at_least_the_basic_wage_re_1'

export const dataPointDefinition = {
  retracedId: 'is_the_fac_failing_to_pay_any_worker_at_least_the_basic_wage_re_1',
  name: 'Is the facility failing to pay any worker AT LEAST the basic wage required under the Collective Bargaining Agreement for any regular hours worked?',
  description:
    'Answer Yes if any worker(s) are not paid the basic wage required under the Collective Bargaining Agreement (above the legal minimum wage, if established, not including bonuses or other supplemental payments). This basic wage can be paid hourly or by piece/unit or other work output.\r\r\n\r\r\nThis question covers all categories of workers.\r\r\n\r\r\nIf there is no basic wage required under the Collective Bargaining Agreement (above the legal minimum wage, if established), answer Not applicable. ',
  meta: {},
  fieldTypeId: 'SELECT',
  type: 'RELATIONAL',
  options: [
    {
      name: 'Yes',
      key: 'YES',
      slcpIndex: 1,
      slcpOptionName: 'ynna',
    },
    {
      name: 'No',
      key: 'NO',
      slcpIndex: 2,
      slcpOptionName: 'ynna',
    },
    {
      name: 'Not Applicable',
      key: 'NOT_APPLICABLE',
      slcpIndex: 3,
      slcpOptionName: 'ynna',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
        enum: ['YES', 'NO', 'NOT_APPLICABLE'],
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'wb-wage-7',
      version: '1.6.0',
      provider: 'slcp',
    },
  ],
  sortingId: 7420,
  sectionId: '2.2.3',
  impactArea: 'Compensation',
  impactAreaId: 'WAGES_AND_BENEFITS',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
